import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { FuseSharedModule } from '@fuse/shared.module';

import { MatSidenavModule } from '@angular/material/sidenav';
import { DialogBoxComponent } from './dialog/dialog-box.component';

import { AnalisisDeBrechasComponent } from './analisis-de-brechas.component';
import { MisAnalisisDeBrechasComponent } from './mis-analisis-de-brechas.component';
import { AnalisisDeBrechasViewComponent } from './analisis-de-brechas-view.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { IniciarAnalisisDeBrechasComponent } from './iniciar-analisis.component';
import { DialogBoxPrintComponentAnalisisDeBrechas } from './dialog/dialog-print-box.component';
import { SentenciaTableComponent} from './component/sentencia-table.component';
import { SentenciaTreeComponent } from './component/sentencia-tree.component';
import { SentenciaResultadoTableComponent} from './component/sentencia-resultado-table.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { TranslateModule } from '@ngx-translate/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatTabsModule} from '@angular/material/tabs';
import {MatStepperModule} from '@angular/material/stepper';
import { DialogBoxCambioEstadoComponent } from './dialog/dialog-box-cambio-estado.component';
import { DialogBoxCopiarComponent } from './dialog/dialog-box-copiar.component';
import { DialogAnalisisBoxAnalyticsComponentAnalisisDeBrechas} from './dialog/dialog-analisis-analytics-box.component';
import { DialogAnalisisComparatorBoxAnalyticsComponentAnalisisDeBrechas} from './dialog/dialog-analisis-analytics-comparator-box.component';

import { DialogAnalisisBoxPrintComponentAnalisisDeBrechas} from './dialog/dialog-analisis-print-box.component';
import { EvaluacionModule } from '../evaluacion/evaluacion.module';
import {MatTreeModule} from '@angular/material/tree';
import { KeysPipe} from './dialog/json-keys.pipe'
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatPaginatorModule } from '@angular/material/paginator';


@NgModule({
    declarations: [
        AnalisisDeBrechasComponent,
        MisAnalisisDeBrechasComponent,
        IniciarAnalisisDeBrechasComponent,
        DialogBoxPrintComponentAnalisisDeBrechas,
        AnalisisDeBrechasViewComponent,
        DialogBoxCambioEstadoComponent,
        DialogBoxCopiarComponent,
        DialogAnalisisBoxPrintComponentAnalisisDeBrechas,
        DialogBoxComponent,
        SentenciaTableComponent,
        SentenciaTreeComponent,
        SentenciaResultadoTableComponent,
        DialogAnalisisBoxAnalyticsComponentAnalisisDeBrechas,
        DialogAnalisisComparatorBoxAnalyticsComponentAnalisisDeBrechas,
        KeysPipe
    ],
    imports     : [
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatAutocompleteModule,
        TranslateModule,
        MatSnackBarModule,
        FuseSharedModule,
        MatIconModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatTabsModule,
        MatStepperModule,
        EvaluacionModule,
        MatSidenavModule,
        MatTreeModule,
        NgxChartsModule,
        MatPaginatorModule
    ],
    entryComponents: [
        DialogBoxPrintComponentAnalisisDeBrechas,
        IniciarAnalisisDeBrechasComponent,
        AnalisisDeBrechasViewComponent,
        DialogBoxCambioEstadoComponent,
        DialogBoxCopiarComponent,
        DialogAnalisisBoxPrintComponentAnalisisDeBrechas,
        DialogBoxComponent,
        SentenciaTableComponent,
        SentenciaTreeComponent,
        SentenciaResultadoTableComponent,
        DialogAnalisisBoxAnalyticsComponentAnalisisDeBrechas,
        DialogAnalisisComparatorBoxAnalyticsComponentAnalisisDeBrechas
    ],
    exports: [SentenciaTableComponent,
                SentenciaTreeComponent,
                SentenciaResultadoTableComponent]

})
export class AnalisisDeBrechasModule
{
}
